import { ReactNode } from 'react';

import classNames from 'classnames';
import { connect } from 'react-redux';

import BackButton from '@src/components/BackButton/BackButton';
import Navigation from '@src/components/Navigation/Navigation';
import ProgressSteps from '@src/components/ProgressSteps/ProgressSteps';
import { CHECK_ELIGIBILITY_STEP_ID } from '@src/containers/Routes/helper/stepActiveIds.helper';
import { useCurrentStep } from '@src/hooks/useCurrentStep';
import LoadingPlaceholder from '@src/loadingPlaceholder/LoadingPlaceholder';
import { RootState } from '@src/reducers';

import styles from './SignupLayout.module.css';
import Modals from '../Modals';

type TProps = {
    children: ReactNode;
};

const mapStateToProps = (state: RootState) => ({
    isApplicationStateLoading: state.fetched.application.loading
});

const SignupLayout = ({
    children,
    isApplicationStateLoading
}: TProps & ReturnType<typeof mapStateToProps>) => {
    const currentStep = useCurrentStep();

    if (isApplicationStateLoading) {
        return (
            <>
                <div data-testid="layout-loader">{LoadingPlaceholder()}</div>
                <Modals />
            </>
        );
    }
    return (
        <>
            <Navigation />
            {/* TODO: Fix progess steps required attributes when refactoring it. */}
            {currentStep !== CHECK_ELIGIBILITY_STEP_ID && (
                <ProgressSteps className={''} />
            )}
            <div
                className={classNames(
                    styles.content,
                    currentStep === 'productOffers' &&
                        styles.productOffersContent,
                    currentStep === CHECK_ELIGIBILITY_STEP_ID &&
                        styles.checkEligibilityContent
                )}>
                <BackButton />
                <div>{children}</div>
            </div>

            <Modals />
        </>
    );
};

export default connect(mapStateToProps)(SignupLayout);
